export default (theme, colors) => ({
    dayLabel: {
        color: colors.neutral900,
    },
});
